import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(theme => ({
  root: {
    color: 'white',
    padding: 25,
  },
  container: {
    background: theme.colors.dark.darkBlue,
    borderRadius: 16,
    width: '30%',
    flex: 1 / 3,
  },
}));
